<template>
	<div>
		<el-form style="text-align:left" label-position="right" label-width="180px" ref="applyForm"  size="small" >
				<el-form-item label="轮播图">
					<el-upload
					  class="upload-demo"
					  multiple
					  list-type="picture-card"
					  action="/wlplat/img/upload"
					  :on-remove="handleRemove"
					  :on-success="handleAvatarSuccess"
					  :file-list="imgFiles"
					  >
					  <el-button size="small" type="primary">点击上传</el-button>
					  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>

				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<script>
	import {indexImgList,indexImgUpdate} from '@/api/api.js'
	import tools from "@/tools"
	export default {
		data(){
			return {
				
				imgs:[],
				
				imgFiles:[],
				addLoading:false
			}

		},
		created:function() {
			var equipId = this.$route.query.equipId;
			console.log(equipId);
			indexImgList().then(res=>{
				var imgs = res.data.data;
				for(var index in imgs){
					this.imgFiles.push({name:"",url:imgs[index]});
					if(this.imgs){
						this.imgs.push(imgs[index]);
					}else{
						this.imgs = []
						this.imgs.push(imgs[index]);
					}
				}
			})
			
		

		},
		methods:{
			addSubmit(){
				this.addLoading=true;
				indexImgUpdate(this.imgs).then(res=>{
					if(res.data.status=="success"){
						this.$message('添加成功');
						this.addLoading=false;
					}
				});	
				this.addLoading=false;	
				
			},
			handleAvatarSuccess(res, file,fileList) {
				console.log(this.imgs)
				if(this.imgs){
					this.imgs.push(res.data);
				}else{
					this.imgs = []
					this.imgs.push(res.data);
				}
				console.log(this.imgs);
		    },
		    handleRemove(file, fileList){

		    	tools.arrayRemove(this.imgs,file.url);

				console.log(this.imgs);
		    },
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>